"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.default = (function () { return (react_1.default.createElement("svg", { width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z", stroke: "#F4B336", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    react_1.default.createElement("path", { d: "M8 12.5H16", stroke: "#F4B336", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))); });
